"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_insights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e554cad7-ef62-4370-9580-8e74f915c750",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 112"
  }, props), /*#__PURE__*/React.createElement("title", null, "market_icn_Insights"), /*#__PURE__*/React.createElement("path", {
    id: "8f214711-ed28-42ab-b7fa-87d16336cd47",
    "data-name": "<Pfad>",
    d: "M96,148c-51.49,0-74.77-48-75.66-50.21a6.19,6.19,0,0,1,0-4C21.23,92,44.51,44,96,44s74.77,48,75.66,50.21a6.19,6.19,0,0,1,0,4C170.77,100,147.49,148,96,148Z",
    transform: "translate(-16 -40)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d1d21c03-04f9-4db3-b20d-b252bf0e5855",
    "data-name": "<Pfad>",
    d: "M96,124a28,28,0,1,1,28-28A27.88,27.88,0,0,1,96,124Z",
    transform: "translate(-16 -40)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var _default = ic_insights;
exports.default = _default;